import { useState, useEffect, useCallback } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Centralized admin auth state.
 * Token IS the admin password (single-admin app, no JWT needed).
 * Stored in localStorage under 'admin_token'.
 */
export const useAdminAuth = () => {
  const [token, setToken] = useState(() => localStorage.getItem("admin_token") || "");
  const [checking, setChecking] = useState(!!localStorage.getItem("admin_token"));
  const [authed, setAuthed] = useState(false);

  const verify = useCallback(async (t) => {
    if (!t) {
      setAuthed(false);
      setChecking(false);
      return false;
    }
    try {
      await axios.get(`${API}/admin/me`, { headers: { "X-Admin-Token": t } });
      setAuthed(true);
      setChecking(false);
      return true;
    } catch {
      setAuthed(false);
      setChecking(false);
      localStorage.removeItem("admin_token");
      setToken("");
      return false;
    }
  }, []);

  useEffect(() => {
    if (token) verify(token);
  }, [token, verify]);

  const login = async (password) => {
    const res = await axios.post(`${API}/admin/login`, { password });
    const t = res.data.token;
    localStorage.setItem("admin_token", t);
    setToken(t);
    setAuthed(true);
    return true;
  };

  const logout = () => {
    localStorage.removeItem("admin_token");
    setToken("");
    setAuthed(false);
  };

  return { token, authed, checking, login, logout };
};

export const adminHeaders = () => ({
  "X-Admin-Token": localStorage.getItem("admin_token") || "",
});
